export default __webpack_public_path__ + "static/media/V450MANG2.2f3ee9a5.pdf";